import { render, staticRenderFns } from "./listOfficers.vue?vue&type=template&id=5c171dbe"
import script from "./listOfficers.vue?vue&type=script&lang=js"
export * from "./listOfficers.vue?vue&type=script&lang=js"
import style0 from "./listOfficers.vue?vue&type=style&index=0&id=5c171dbe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports